import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AppVersionModel } from 'common/models/page-models/App Version Model/app-version-form-model';
import { FormResolverService } from 'common/resolvers/core-resolvers/form-resolver';
import { SystemService } from 'common/services/core-services/system.service';
import { AppVersionFormWidgetService } from 'common/widget/app-version/app-version-form-widget.service';

@Injectable({
    providedIn: 'root'
})
export class AppVersionFormResolver extends FormResolverService<AppVersionModel> {
    constructor(
        protected fs: AppVersionFormWidgetService,
        protected override router: Router,
        protected override systemService: SystemService
    ) {
        super(fs, router, systemService);
    }
}
